var React = require('react');

function IOS (props) {
    return React.createElement("svg",props,React.createElement("text",{"id":"_","data-name":"","transform":"translate(0 34)","fill":"#1e1c24","fontSize":"36","fontFamily":"SFProText-Light, SF Pro Text","fontWeight":"300"},React.createElement("tspan",{"x":"0","y":"0"},"")));
}

IOS.defaultProps = {"width":"26","height":"43","viewBox":"0 0 26 43"};

module.exports = IOS;

IOS.default = IOS;
